const variables = {};

variables.host = window.location.href.split('/').slice(0, 3).join('/');

variables.wpApiPath = `${variables.host}/wp-json/wp/v2/`;

variables.env = document.querySelector('meta[name="environment"]').content;

variables.tabletMax = 992;

variables.boostrapBreakPoints = [480, 768, 992, 1200];

variables.breakpoints = {
  phone: variables.boostrapBreakPoints[0],
  tablet: variables.boostrapBreakPoints[1],
  desktop: variables.boostrapBreakPoints[2],
  cinema: variables.boostrapBreakPoints[3],
};

variables.rotatorSpeed = 900;

variables.rotatorTimeout = 6500;

variables.siteDomains = [window.location.host, 'paulbunyan.local', 'pbc2017.localhost', 'paulbunyan.net', 'pbc2017.pbndev.net'];

variables.loading = '<div class="loading"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x loading-bg"></i><i class="fa fa-refresh fa-spin fa-stack-1x fa-inverse loading-spinner"></i></span></div>';

variables.loadingError = '<div class="loading-error"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x loading-error-bg"></i><i class="fa fa-exclamation-triangle fa-stack-1x fa-inverse loading-error-icon"></i></span></div>';

export default variables;
